const dotThousandsFormatter = new Intl.NumberFormat("de-DE", {
  maximumFractionDigits: 0,
});

/** Integer display with "." as thousands separator (e.g. 17.723). */
export default function formatIntegerDotThousands(value) {
  const n = Number(value);
  if (!Number.isFinite(n)) return "";
  return dotThousandsFormatter.format(n);
}
